import React from 'react';
import ChatIcon from './ChatIcon';

export default function ChatMessage({ message, onNavigate }) {
  const isUser = message.role === 'user';
  return (
    <article className={`chat-message ${isUser ? 'chat-message-user' : 'chat-message-assistant'}`}>
      {!isUser && <span className="chat-avatar"><ChatIcon name="drop" /></span>}
      <div className="chat-message-content">
        <p className="chat-message-text whitespace-pre-wrap">{message.content}</p>
        {message.sources?.length > 0 && <div className="chat-sources">{message.sources.map((source, index) => (
          <span className="chat-source" key={index} title={[source.title, source.section].filter(Boolean).join(' · ')}><ChatIcon name="book" /><span>{source.title}{source.section ? ` · ${source.section}` : ''}</span></span>
        ))}</div>}
        {message.suggestions?.length > 0 && <div className="chat-shortcuts">{message.suggestions.map((suggestion) => (
          <button key={suggestion.route} onClick={() => onNavigate(suggestion.route)}>{suggestion.label}<ChatIcon name="external" /></button>
        ))}</div>}
      </div>
    </article>
  );
}
